import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import "moment/locale/fr";
import ConfirmButton from "./../buttons/ConfirmButton";
import MenuAdmin from "./../../pages/admin/Menu";
import { importApiUpsellProvider } from "../../lib/api/providers";
import { Form, Input, DatePicker, Icon, Upload, Button, message, Alert, Spin } from "antd";

class ImportForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: "",
      loading: false,
      success: false,
      error: false,
      message: "",
      errors: [],
      results: [],
      response: null
    };
  }

  onFormSubmit = e => {
    e.preventDefault();
    let data = new FormData();

    let file = this.state.file;
    data.append("file", file);
    data.append("client_id", this.props.currentClient.id);

    if (this.state.loading) return;

    this.setState({
      loading: true,
      message: "Importation en cours ...",
      error: false,
      success: false,
      response: null
    });

    importApiUpsellProvider
      .post(this.props.importUri, data, {
        headers: {
          Authorization: this.props.token
        }
      })
      .then((d = {}) => {
        this.setState({
          loading: false,
          message: "Importation réussie",
          error: false,
          success: true,
          response: d.data
        });
      })
      .catch(e => {
        const response = e.response || {};
        const msg = response.data || "";

        this.setState({
          loading: false,
          message: `Une erreur est survenue. (${msg})`,
          error: true,
          success: false,
          response: response.data
        });
      });
    //this.props.importFile(this.props.importUri, data);
  };
  onChange = e => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ file: files[0] });
  };

  getErrorMessage() {
    const data = this.state.response || {};
    if (data.error) {
      return Array.isArray(data.error) ? data.error : [data.error];
    }

    return [this.state.message];
  }

  getSuccessMessage() {
    const data = this.state.response || {};
    console.log(data);
    if (data.error) {
      return data.error;
    }

    if (data.message) {
      return data.message;
    }

    if (data.hasOwnProperty("success") && data.hasOwnProperty("failed")) {
      let msg = `Importation de ${data.success} élément${data.success > 1 ? "s" : ""} sur ${data.success +
        data.failed}.`;

      if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
        for (let i = 0; i < data.errors.length; i++) {
          const { line = "", message = "" } = data.errors[i];

          msg += `${"\n\r"}${line ? "Ligne " + line + ": " : ""}${message}`;
        }
      }
      return msg;
    }
    return this.state.message;
  }

  renderSuccess() {
    return (
      <div className="p-mrg-bot">
        <Alert style={{ "white-space": "pre-line" }} message={this.getSuccessMessage()} type="success" showIcon />
      </div>
    );
  }

  renderError() {
    const err = () => {
      return (
        <div style={{ maxHeight: 150, overflowY: "auto" }}>
          <div />
          {this.getErrorMessage().map((i, key) => {
            return (
              <div style={{ marginBottom: 5 }} key={key}>
                {i}
              </div>
            );
          })}
        </div>
      );
    };
    return (
      <div className="p-mrg-bot">
        <Alert message={"Echec de l'importation"} description={err()} type="error" showIcon />
      </div>
    );
  }

  _renderError() {
    return (
      <div className="p-mrg-bot">
        <Alert message={this.getErrorMessage()} type="error" showIcon />
      </div>
    );
  }

  renderForm() {
    const { title } = this.props;
    return (
      <form onSubmit={this.onFormSubmit}>
        <div>Choisissez ci-dessous votre fichier {title} (format excel).</div>
        <div style={{ marginTop: 15 }}>
          <input type="file" name="file" id="file" onChange={this.onChange} className="p-import-file" />
          <label htmlFor="file" className="p-import-btn">
            {this.state.file ? this.state.file.name : "Choisir un fichier"}
          </label>
        </div>
        <div style={{ marginTop: 15 }}>
          <ConfirmButton disabled={!this.state.file} label={"Importer"} large={true} onClick={this.onFormSubmit} />
        </div>
      </form>
    );
  }

  renderLoadingForm() {
    return <Spin tip="Chargement...">{this.renderForm()}</Spin>;
  }

  render() {
    return (
      <Fragment>
        {this.state.error ? this.renderError() : null}
        {this.state.success ? this.renderSuccess() : null}
        {this.state.loading ? this.renderLoadingForm() : this.renderForm()}
      </Fragment>
    );
  }
}

ImportForm.prototypes = {
  title: PropTypes.string,
  importUri: PropTypes.string.isRequired
};

export default ImportForm;



// WEBPACK FOOTER //
// src/components/admin/ImportForm.js